import { graphql } from "babel-plugin-relay/macro";

export const SHOW_ANSWER_CONTAINER_FRAGMENT = graphql`
	fragment showAnswerButtonContainer_NodeFragment on LearnOpportunityV2 {
		id
		root {
			id
		}
		typeDefinition {
			... on LearnOpportunityBranchTypeDefinition {
				children {
					id
					typeDefinition {
						... on LearnOpportunityELearningContentTypeDefinition {
							containedElementTypes
						}
					}
					...showAnswersButton_LearnOpportunityFragment
				}
			}
			definitionType
		}
		...showAnswersButton_LearnOpportunityFragment
	}
`;
